import ReactDOM from 'react-dom/client'

import App from './App'

import './styles/fonts.css'
import './index.css'
import './styles/theme.css'
import './styles/table-styles.css'
// Last: the app-wide no-bounce policy overrides component overscroll rules.
import './styles/no-elastic-scroll.css'

import { initAnalytics } from './lib/analytics'
import { initFocusModality } from './lib/focus-modality'
import { initOverscrollLock } from './lib/overscroll-lock'
import { initPersonalThemeAttribute } from './lib/personal-theme'
import { enableNaturalLanguageSpellcheck } from './lib/spellcheck'
import { useAuth } from './store/auth.store'

initAnalytics()
// Stamp the warm-hearth attribute before first paint (personal spaces only).
initPersonalThemeAttribute()
// Track mouse vs keyboard so script-returned focus after a mouse click does not
// paint the keyboard outline.
initFocusModality()
initOverscrollLock()
enableNaturalLanguageSpellcheck()

// Import debug utilities in development mode
import.meta.env.DEV && import('./lib/realtime/debug/debug-utils')

// Load debug utilities in development mode
if (import.meta.env.DEV) {
  import('./lib/realtime/debug-controls')
}

// Clear any stale confirmation or registration state
if (
  window.location.pathname === '/login' ||
  window.location.pathname === '/register'
) {
  localStorage.removeItem('scrambl-login-session')
}

// Initialize the auth store with defaults, but only if not already initialized
// This prevents double-initialization which could cause timing issues
if (!useAuth.getState().lastAuthCheckTime) {
  // Only set default values if they're not already set
  const currentState = useAuth.getState()

  useAuth.setState({
    ...currentState, // Keep existing methods and values

    // Only set these values if they're not already set
    user: currentState.user ?? null,
    isAuthenticated: currentState.isAuthenticated ?? false,
    isLoading: currentState.isLoading ?? true,
    isAuthReady: currentState.isAuthReady ?? false,
    lastAuthCheckTime: currentState.lastAuthCheckTime ?? null,
  })
}

// Create root element
const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

// Create root and render the App
const root = ReactDOM.createRoot(rootElement)
root.render(<App />)
